import { render, staticRenderFns } from "./BatchModifyPrice.vue?vue&type=template&id=0a380441&scoped=true"
import script from "./BatchModifyPrice.vue?vue&type=script&lang=js"
export * from "./BatchModifyPrice.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyPrice.vue?vue&type=style&index=0&id=0a380441&prod&scoped=true&lang=css"
import style1 from "./BatchModifyPrice.vue?vue&type=style&index=1&id=0a380441&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a380441",
  null
  
)

export default component.exports